<template>
  <div>
    <client-credentials-add
      :is-active="isModalActive"
      :customer-id="Number(this.$route.params.id)"
      :is-add="isAdd"
      :is-edit="isEdit"
      :action="action"
      :edit-object-name="editObjectName"
      @confirm="editConfirm"
      @cancel="editCancel"
    />
    <credentialsUpload
      :is-active="uploadCredentialsVisible"
      :customer-id="Number(this.$route.params.id)"
      @close="uploadCredentialsVisible = false"
      @confirm="editConfirm"
    />

    <div class="level no-margin">
      <div class="level-left"></div>
      <div class="level-right" v-if="disableActionItem()">
        <div class="level-item-horizontal">
          <ul class="context-options-right">
            <li>
              <a @click.prevent="addModal" data-cy="add-new-client-credentials"
                >Add new</a
              >
            </li>
            <li>
              <a
                @click.prevent="uploadClientCredentials"
                data-cy="import-client-credentials"
                >Import</a
              >
            </li>
            <li>
              <a
                @click.prevent="exportClientCredentials"
                data-cy="export-client-credentials"
                >Export selected</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div>
      <circul8-table
        :records="data"
        :fields="columns"
        :routeNext="false"
        :usePropRecords="true"
        @clickcheck="checkCheckBox"
        @clickEdit="editModal"
        @clickView="viewModal"
        :infoPosition="0"
        @clickDelete="deleteModal"
        :showRemoveButton="showDelete"
        :showEditButton="showEdit"
        :isCheckable="true"
      />
    </div>
  </div>
</template>

<script>
import { forkJoin } from "rxjs";
import ClientCredentialsAdd from "@/components/Customers/ClientCredentialsAdd";
import ClientCredentialsService from "@/services/ClientCredentialsService";
import CredentialsUpload from "@/components/Customers/CredentialsUpload";
import CustomerProfileDataService from "../../services/CustomerProfileDataService";
import Circul8Table from "../../components/Circul8Table.vue";
import utilityMixin from "@/mixins/UtilityMixin";
import ScopeMixin from "@/mixins/scopeMixin";
import { Permission } from "../../services/Permissions";
import { mapGetters } from "vuex";
// @group Customers
export default {
  name: "ClientCredentialsView",
  mixins: [utilityMixin, ScopeMixin],
  components: {
    ClientCredentialsAdd,
    CredentialsUpload,
    Circul8Table
  },

  props: {
    checkable: {
      type: Boolean,
      default: false
    },
    contactAction: {
      type: Boolean,
      default: false
    },
    customerAccountManager: {
      type: Number,
      default: 0
    },
    backupCustomerAccountManager: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isModalActive: false,
      uploadCredentialsVisible: false,
      isAdd: false,
      isEdit: false,
      action: null,
      editObject: this.getClearFormObject(),
      tableHeight: "",
      users: [],
      checkedRow: [],
      data: [],

      customers: [],
      customerMap: {},
      containerMap: {},
      countryMap: {},
      schemeMap: {},
      columns: [
        {
          field: "customer",
          label: "Customer",
          width: "200"
        },
        {
          field: "country",
          label: "Country",
          width: "200"
        },
        {
          field: "stream",
          label: "Stream",
          width: "200"
        },
        {
          field: "scheme",
          label: "Scheme",
          width: "200"
        },
        {
          field: "username",
          label: "Username",
          class: "enable-select-text"
        },
        {
          field: "password",
          label: "Password",
          class: "enable-select-text"
        },
        {
          field: "website",
          label: "Website",
          class: "enable-select-text"
        },
        {
          field: "additional_info",
          label: "Additional Info",
          class: "enable-select-text"
        },
        {
          field: "actions",
          label: "",
          headerClass: "is-actions",
          cellClass: "is-actions"
        }
      ],

      clientCredentialsService: new ClientCredentialsService(),

      customerDataService: new CustomerProfileDataService()
    };
  },
  computed: {
    ...mapGetters(["userId", "userName", "userHasPermission"]),
    editObjectName() {
      return this.editObject || this.getClearFormObject();
    },
    countryList() {
      return this.$store.state.countryList;
    },
    schemeList() {
      return this.$store.state.schemeList;
    },
    containerList() {
      return this.$store.state.containerList;
    }
  },
  watch: {
    customerAccountManager(newValue) {
      //Watches value of CAM and triggers this function if value of CAM changes
      this.fetchClientCredentialData();
    }
  },
  mounted() {
    this.fetchCountries();
    this.fetchSchemes();
    this.fetchContainers();
    forkJoin(this.fetchCustomerList()).subscribe(parents => {
      this.fetchClientCredentialData();
    });
  },

  methods: {
    checkCheckBox(d) {
      this.checkedRow = d;
    },

    getClearFormObject() {
      return {
        id: null,
        customer: Number(this.$route.params.id),
        country: null,
        scheme: null,
        stream: null,
        update_date: null,
        username: null,
        password: null,
        additional_info: null,
        website: null
      };
    },
    addModal() {
      this.isAdd = true;
      this.isEdit = false;
      this.action = "Add";
      this.editObject = this.getClearFormObject();
      this.isModalActive = true;
    },
    editModal(editObject) {
      this.isAdd = true;
      this.isEdit = true;
      this.action = "Update";
      this.fetchClientCredentialSingleData(editObject);
      this.isModalActive = true;
    },
    viewModal(editObject) {
      this.isAdd = false;
      this.isEdit = false;
      this.action = "View";
      this.fetchClientCredentialSingleData(editObject);
      this.isModalActive = true;
    },
    deleteModal(editObject) {
      this.isAdd = false;
      this.action = "Delete";
      this.fetchClientCredentialSingleData(editObject);
      this.isModalActive = true;
    },
    editConfirm(response) {
      this.fetchClientCredentialData();
      this.isModalActive = false;
      this.checkedRow = [];
      //this.$router.go();
    },
    editCancel() {
      this.isModalActive = false;
    },
    exportClientCredentials() {
      try {
        const set = new Set(
          this.checkedRow.map(cc => cc.id).map(result => JSON.stringify(result))
        );
        this.clientCredentialsService.export(
          Array.from(set).map(elem => JSON.parse(elem)),
          Number(this.$route.params.id)
        );
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Upload Error !!!",
          message: e.message,
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },
    uploadClientCredentials() {
      this.uploadCredentialsVisible = true;
    },

    fetchCustomerList() {
      const customerObservable = this.customerDataService.getCustomerList(
        this.customerId
      );
      customerObservable.subscribe(
        customerProfiles => {
          this.customers = customerProfiles;
          this.customerMap = this.prepareMasterData(this.customers);
        },
        e => {
          console.log(e);
        }
      );
      return customerObservable;
    },
    prepareData(data) {
      for (const report in data) {
        data[report]["customer"] = this.customerMap[data[report].customer];
        data[report]["country"] = this.countryMap[data[report].country];
        data[report]["stream"] = this.containerMap[data[report].stream];
        data[report]["scheme"] = this.schemeMap[data[report].scheme];
        data[report]["actions"] = this.isEditAllowed();
        data[report]["delete"] = this.isEditAllowed();
      }
      this.data = data;

      if (this.data.length >= 10) {
        this.tableHeight = "height:560px";
      }
    },
    prepareMasterData(data) {
      const resultDict = {};
      for (const idx in data) {
        const dataDict = data[idx];
        resultDict[dataDict["id"]] = dataDict["name"];
      }
      return resultDict;
    },
    handleApiError(reason) {
      let errorMessage = null;
      if (reason?.response?.data) {
        if (reason.response.data["detail"]) {
          errorMessage = reason.response.data["detail"];
        } else if (reason.response.data["error"]) {
          errorMessage = reason.response.data["error"];
        } else if (reason.response.data["name"]) {
          errorMessage = reason.response.data["name"];
        }
      }

      if (errorMessage != null && errorMessage != undefined) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: errorMessage,
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },
    fetchClientCredentialSingleData(editObjectName) {
      this.clientCredentialsService
        .getAll(this.$route.params.id, editObjectName.id)
        .subscribe(response => {
          this.editObject = response;
        }, this.handleApiError);
    },
    isEditAllowed() {
      if (this.$route.fullPath.includes("/view/")) {
        this.showDelete = false;
        this.showEdit = false;
        return false;
      }
      if (
        this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL) ||
        (this.userHasPermission(Permission.CUSTOMER_PROFILE_CHANGE_CAM) &&
          (this.customerAccountManager == this.userId ||
            this.backupCustomerAccountManager == this.userId))
      ) {
        this.showDelete = true;
        this.showEdit = true;
        return true;
      } else {
        this.showDelete = false;
        this.showEdit = false;
        return false;
      }
    },
    fetchClientCredentialData() {
      this.isLoading = true;
      this.clientCredentialsService
        .getAll(this.$route.params.id)
        .subscribe(response => {
          this.isLoading = false;
          this.prepareData(response);
        }, this.handleApiError);
    }
  }
};
</script>
